import { Link } from "react-router-dom";
import {
  List,
  ListItem,
  Divider,
  ListItemText,
  ListItemButton,
  ListItemIcon,
  Typography,
} from "@common-ui/ui";
import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import AddCardOutlinedIcon from "@mui/icons-material/AddCardOutlined";
import { listTextColor } from "../../pages/Home";

export const QuickActionList = (props) => {
  return (
    <List sx={{ width: "100%", maxWidth: "100%" }}>
      <ListItem alignItems="flex-start" style={{ cursor: "pointer" }}>
        <ListItemButton
          component={Link}
          to={`/work-events/${props.orgId}/create-work-event`}
        >
          <ListItemIcon sx={listTextColor}>
            <AddCardOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            sx={listTextColor}
            primary={<Typography>Create New Work Event</Typography>}
          />
        </ListItemButton>
      </ListItem>
      <Divider variant="middle" />
      <ListItem alignItems="flex-start" style={{ cursor: "pointer" }}>
        <ListItemButton component={Link} to={`/customers`}>
          <ListItemIcon sx={listTextColor}>
            <GroupsOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            sx={listTextColor}
            primary={<Typography>Add a Client</Typography>}
          />
        </ListItemButton>
      </ListItem>
      <Divider variant="middle" />
      <ListItem alignItems="flex-start" style={{ cursor: "pointer" }}>
        <ListItemButton component={Link} to={`/asset-list`}>
          <ListItemIcon sx={listTextColor}>
            <CreateNewFolderOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            sx={listTextColor}
            primary={<Typography>Add an Asset</Typography>}
          />
        </ListItemButton>
      </ListItem>
      <Divider variant="middle" />
    </List>
  );
};
